export class CommentEntry{
    id: number;
    carrierId: number;
    comment: string;
    insertedOn: Date;
    insertedOnFormatted: string;
    insertedBy: string;
    tags: string;
    visibilityRole: string;
    canEdit = false;
    ageMs: number;
}